module.exports = __webpack_public_path__ + "static/media/postal-saude.03d2503e.jpg";